import angular from 'angular';
import clickOutside from './ClickOutside/ClickOutsideService';
import deleteElementDialog from '../../DeleteElementModal/deleteElement';
import workspaceElement from './WorkspaceElement/WorkspaceElement';
import gettext from 'angular-gettext';

const creatorWorkspace = {
    bindings: {
        sections: '<',
        context: '<',
        type: '@', // {workspace|bag}
        options: '<', // {parentModel: }
        sectionsNested: '<',
        content: '='
    },
    template: require('./workspace.html'),
    controller: function ($element) {
        /** @ngInject() */


        this.$onInit = () => {
            this.type = this.type ? this.type : 'workspace';
            this.dragularScope = this.context.getDragularScope();
        };

        this.$postLink = () => {

            /**
             * Dragular bugfix https://github.com/bevacqua/dragula/issues/527
             * When click on section blur (unfocus) all contenteditable elements
             */
            let blurEditableOnClick = () => {
                let editableSelector = '[contenteditable]';
                $element.on('mousedown', function (el) {
                    let clickedInsideEditable = el.target.closest(editableSelector, $element);
                    if (!clickedInsideEditable) {
                        $element.find(editableSelector).each((key, el) => {
                            el.blur();
                        });
                    }
                });
            };

            if(this.type === 'workspace') {
                blurEditableOnClick();
            }
        };
    }
};

export default angular.module('cms.creator.workspace', [
    clickOutside,
    deleteElementDialog,
    gettext,
    workspaceElement
]).component('creatorWorkspace', creatorWorkspace).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/Workspace/Workspace.js